import { EnvMicroAgreement } from "lib-klab-core";

export const envAgreementLocal: EnvMicroAgreement = {
  host: "",
  apiBasePath: "/ms-agreement",
  useMocks: false,
};

export const envAgreementDev: EnvMicroAgreement = {
  host: "https://gatewayapi-dev.erp.inclub.world",
  apiBasePath: "/ms-agreement",
  useMocks: false,
};

export const envAgreementProd: EnvMicroAgreement = {
  host: "https://gatewayapi.erp.inclub.world",
  apiBasePath: "/ms-agreement",
  useMocks: false,
};
